const getHotelMultiOccParam = ({ adultCount, childrenAges }) => {
  const validChildAges = Array.isArray(childrenAges) ? childrenAges.filter(Boolean) : []
  const childrenCount = validChildAges.length
  const childrenAgesParam = childrenCount > 0
    ? validChildAges.join(',')
    : ''
  let multiOcc = ''

  if (adultCount !== 2 || childrenCount > 0) {
    multiOcc = `/adults/${adultCount}`
    if (childrenCount > 0) {
      multiOcc = `${multiOcc}/children/${childrenAgesParam}`
    }
  }

  return multiOcc
}

export default getHotelMultiOccParam
